export enum ListViewPredefinedFilterMode {
  show = 1,
  hide = 2,
}